import { gql } from '@/__generated__';

export const EVENT_PRICE_QUERY = gql(`
    query eventPriceEntries {
        eventPriceFieldEntries {
            ...eventPriceCard
        } 
    }
`);

export const EVENT_TIME_QUERY = gql(`
    query eventTimeEntries($date: [QueryArgument]) {
        eventTimeFieldEntries(date: $date, orderBy: "date ASC") {
            ...eventTimeCard
        } 
    }
`);

export const EVENT_INDEX_QUERY = gql(`
    query eventIndexEntries(
        $genreCategory: [QueryArgument],
        $venueCategory: [QueryArgument],
        $accessibilityCategory: [QueryArgument],
        $programCategory: [QueryArgument],
        $eventTypeCategory: [QueryArgument],
        $educationEvent: Boolean,
        $id: [QueryArgument],
        $orderBy: String,
        $conceal: Boolean
      ) {
        eventEntries(genreCategory: $genreCategory, venueCategory: $venueCategory, accessibilityCategory: $accessibilityCategory, programCategory: $programCategory, eventTypeCategory: $eventTypeCategory, educationEvent: $educationEvent, id: $id, orderBy: $orderBy, conceal: $conceal) {
            ...eventCard
        }
    }
`);
